import { TextExposedField } from "nystem-components";
import React from "react";

const GpsExposedField = (props) => <TextExposedField {...props} />;

export default GpsExposedField;
